import { atom } from 'recoil';

export const positionParentsAtom = atom<number[]>({
	key: 'positionParents',
	default: [],
});
